import React from 'react'

const Outputfield = (props) => {
    let style = {
        backgroundColor: props.backgroundColor,
        color: props.color,
        height: props.height,
        margin: props.margin,
        padding: props.padding,
        justifyContent: props.justifyContent
    }

    const boldClass = props.bold ? 'bold' : null
    const label = props.label ? <div className={`output-field__label ${boldClass}`}>{props.label}</div> : null

    const classes = [
        'output-field',
        boldClass
    ]

    return (
        <>
            {label}
            <div className={classes.join(' ')} style={style}>
                <div className="output-field__value">
                    {props.value}
                </div>
            </div>
        </>
    )
}

export default Outputfield